export default __webpack_public_path__ + "static/media/tilebefore.b82d7761.jpg";